document.addEventListener('DOMContentLoaded', function() {
    // Function to set target="_self"
    function setLinkTargets() {
        const links = document.querySelectorAll('.perspective-widget a');
        links.forEach(function(link) {
            link.setAttribute('target', '_self');
            // Also prevent any JavaScript from changing it later
            Object.defineProperty(link, 'target', {
                value: '_self',
                writable: false,
                configurable: false
            });
        });
    }

    // Run immediately
    setLinkTargets();

    // Also run after a short delay to catch any dynamic changes
    setTimeout(setLinkTargets, 100);
});